import {Set} from '~commonInfra/utils/Set';

import {Formatters, Messages} from '../../codegen/Localize';
import {openReactConfirmationDialog} from '../../commonInfra/dialogs/ReactConfirmationDialog';
import {TabDialogWidth} from '../../commonInfra/dialogs/style/TabDialogWidth';
import {IResult} from '../../httpClient/serverApi/types/IResponse';
import {
  UserActionNotification,
  UserActionNotificationParams
} from '../../userManagement/services/notifications/UserActionNotification';
import {ServerUsers} from '../../userManagement/services/resources/ServerUsers';
import {IServerUser} from '../../userManagement/users/serverApi/types/IServerUser';
import {ISiteUser} from '../../userManagement/users/serverApi/types/ISiteUser';
import {IUser} from '../../userManagement/users/serverApi/types/IUser';
import {IUserActionResult, UserActionResultCode} from '../../userManagement/users/serverApi/types/IUserActionResult';


export function resetLoginRateLimitingOnSiteUsers(siteUsers: Set<ISiteUser>): Promise<any> {
  return resetLoginRateLimiting(siteUsers,
    ServerUsers.instance.resetLoginRateLimitingOnSiteUsers.bind(ServerUsers.instance));

}

export function resetLoginRateLimitingOnServerUsers(serverUsers: Set<IServerUser>): Promise<any> {
  return resetLoginRateLimiting(serverUsers,
    ServerUsers.instance.resetLoginRateLimiting.bind(ServerUsers.instance));
}

function resetLoginRateLimiting(users: Set<IUser>,
                                requestTrigger: (userIds: string[]) => Promise<IUserActionResult>): Promise<any> {
  const dialogBody = Messages.confirmResetLoginRateLimiting({
    USER_COUNT: users.size(),
    USER_NAME: users.first().displayName,
    USER_COUNT_LOC: Formatters.formatCount(users.size())
  });

  const dialogInstance = openReactConfirmationDialog<void, IResult>({
    title: Messages.resetLoginRateLimitingTitle(),
    message: dialogBody,
    paramsForAction: undefined,
    action: () => requestTrigger(users.keys()),
    actionName: Messages.confirmResetLoginRateLimitingButton({
      ITEM_COUNT: users.size(),
      ITEM_COUNT_LOC: Formatters.formatCount(users.size())
    }),
    isActionDelete: false,
    dialogWidth: TabDialogWidth.width375px
  });

  dialogInstance.result.then((result: IUserActionResult) => {
    const params: UserActionNotificationParams = {
      users: users,
      results: result.results,
      errors: result.errors,
      successCode: UserActionResultCode.userResetLoginRateLimiting,
    };
    UserActionNotification.instance.notify(params);
  });
  return Promise.resolve(dialogInstance.result);
}